export default "__VITE_ASSET__pOXOLHH9EmP_EUmAXFH0nQ__"